const templateUrl = require('./sent-shipment-footer.html');

const app = angular.module('msi.shipments.sentShipmentFooter', []);

app.component('ogSentShipmentFooter', {
  bindings: {
    shipment: '<ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
